import React, { FormEvent, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../../contexts/AuthContext";
import Input from "../../../components/Form/Input";
import Button from "../../../components/Form/Button";
import Select from "../../../components/Form/Select";
import Checkbox from "../../../components/Form/Checkbox";

import { RouteProps } from "react-router-dom";
import { SimpleResponse } from "../../../services/api/Request";
import User, { IUser } from "../../../services/api/User";
import { IGroup } from "../../../services/api/Group";
import { IProfile } from "../../../services/api/Profile";
import { SetModal } from "../../../components/Modal";
import Tooltip from "./Tooltip";
// import { Tooltip } from "reactstrap";

interface FormProps extends RouteProps {
  userEdit: IUser;
  profiles: IProfile[];
  groups: IGroup[];
}

const Form: React.FC<FormProps> = ({ userEdit, profiles, groups }) => {
  const { user } = useContext(AuthContext);
  const [response, setResponse] = useState<SimpleResponse>();
  const isUpdate = userEdit && userEdit.id;
  const readOnly = user!.profile.name === "Viewer";
  const history = useHistory();

  async function handleFormSubmit(event: FormEvent) {
    event.preventDefault();

    const formData: FormData = new FormData(event.target as HTMLFormElement);
    let data: any = {};
    formData.forEach((value: FormDataEntryValue, key: string) => {
      data[key] = key === "group" || key === "profile" ? { id: value } : value;
    });

    const response: SimpleResponse = await (isUpdate
      ? User.Update(userEdit.id, data)
      : User.Create(data));

    setResponse(response);
  }

  function listGroups(group: IGroup[]): any {
    let result: object[] = [];
    for (let g of group) {
      result.push({ value: g.id, label: g.name });
      if (g.children) result = result.concat(listGroups(g.children));
    }
    return result;
  }

  function listProfiles(profile: IProfile): any {
    return { value: profile.id, label: profile.name };
  }

  function closeForm(e: any) {
    e.preventDefault();
    e.target.parentNode.parentNode.classList.remove("form--open");
    const contentWrapper = document.querySelector("#content");
    if (contentWrapper != null) {
      if (contentWrapper.classList.contains("form--open")) {
        contentWrapper.classList.toggle("form--open");
      }
    }
  }

  return (
    <React.Fragment>
      {response ? SetModal.FromResponse(response, () => {
        setResponse(undefined);
        if (response.status === 200) {
          history.push({ pathname: "/empty" });
          history.goBack();
        }
      }) : null}
      <form
        className="container form form--border form--small"
        onSubmit={handleFormSubmit}
      >
        <button onClick={closeForm} className="form__close close"></button>

        <h3 className="form__title">{isUpdate ? "Update" : "Add New"} User</h3>

        <Input
          disabled={readOnly}
          id={'name' + userEdit.id}
          name="name"
          title="Name"
          value={userEdit.name}
        />
        <Input
          disabled={readOnly}
          id={'email' + userEdit.id}
          name="email"
          title="Email"
          value={userEdit.email}
          type="email"
        />
        <Select
          disabled={readOnly}
          labelClass="form__label"
          name="profile"
          title="Profile"
          options={profiles.map(listProfiles)}
          defaultValue={userEdit.profile ? userEdit.profile.id : ""}
        />

        <Select
          disabled={readOnly}
          labelClass="form__label"
          name="group"
          title="Group"
          options={listGroups(groups)}
          defaultValue={userEdit.group ? userEdit.group.id : ""}
        />

        <div className="form__group-container">
          <Checkbox
            id={'active' + userEdit.id}
            disabled={readOnly}
            name="active"
            title="Active"
            value="true"
            checked={userEdit.active}
          />

          <Tooltip />

          <Button
            disabled={readOnly}
            className="button button--blue button--icon button--save"
            title={isUpdate ? "Save" : "Send"}
          />
        </div>
      </form>
    </React.Fragment>
  );
};

export default Form;
